// ==========================================
// ENUMS
// ==========================================
export const TypeBadge = {
	GOLD: "Oro",
	SILVER: "Plata",
	BRONZE: "Bronce",
} as const;

export type TypeBadge = (typeof TypeBadge)[keyof typeof TypeBadge];

// ==========================================
// RESPONSE TYPE (Lo que recibes del Backend)
// ==========================================
export interface BadgeResponse {
	type: string; // "badge"
	id: number;
	name_badge: string;
	description_badge?: string | null;
	icon_badge: string; // URL de la imagen
	type_badge: TypeBadge; // "Oro" | "Plata" | "Bronce"
	is_active: boolean;
	created_at: string;
	updated_at: string;
}

// ==========================================
// PAYLOAD TYPES (Lo que envías al Backend)
// ==========================================
export interface CreateBadgePayload {
	name_badge: string;
	description_badge?: string;
	type_badge: TypeBadge;
	// icon_badge se maneja como File aparte en el hook
}

export interface UpdateBadgePayload {
	name_badge?: string;
	description_badge?: string;
	type_badge?: TypeBadge;
}

// ==========================================
// SUB-TYPES (Detalles anidados en la asignación)
// ==========================================

export interface BadgeSummary {
	id: number;
	name_badge: string;
	description_badge?: string | null;
	icon_badge: string;
	type_badge: TypeBadge; // "Plata", "Oro", etc.
	is_active: boolean;
}

export interface ProviderSummaryInBadge {
	id: number;
	user_id: number;
	company_name: string;
	description_provider: string;
	rating: number;
	verified_provider: boolean;
	languages_provider: string;
	availability: boolean;
	is_banned: boolean;
	experience_years: number | null;
}

// ==========================================
// RESPONSE TYPE: BADGE ASSIGNMENT
// ==========================================
export interface BadgeAssignmentResponse {
	type: string; // "badge-assignment"
	id: number;
	badge_id: number;
	provider_id: number;
	assigned_date: string; // ISO String
	created_at: string;
	updated_at: string;
	is_active: boolean;

	// Objetos poblados
	badges: BadgeSummary;
	providers: ProviderSummaryInBadge;
}
